const PASSWORD_CHANGE_REQUEST_PATHS = [
  '/api/v1.1/passwordreset/createsudopassword',
  '/api/v1.1/passwordreset/validatepassword',
  '/api/v1.1/passwordreset/changepasswordv2',
] as const;

export function isPasswordChangeRequestUrl(url: string | undefined) {
  return url !== undefined && PASSWORD_CHANGE_REQUEST_PATHS.some((path) => url.includes(path));
}

export function isExpectedPasswordChangeError(url: string | undefined, statusCode: number | undefined) {
  return (
    isPasswordChangeRequestUrl(url) &&
    (statusCode === 400 || statusCode === 401 || statusCode === 403 || statusCode === 422)
  );
}
